import type { Pead } from "epsm-api-types/models";

export function getQuarter({ data }: { data: Pead }) {
	const edMonth = data.earning_day.getMonth() + 1;
	const edYear = data.earning_day.getFullYear();

	return `${edMonth.toString().padStart(2, "0")}/${edYear.toString().slice(-2)}`;
}
